module.exports = "<svg id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45.85 668\"><defs><style>.cls-1{fill:#61abcf;}</style></defs><title>Rectangle</title><path class=\"cls-1\" d=\"M0,0l46,0,0,668.17-46,0S42.85,561.5,42.85,333.5C42.85,102.5,0,0,0,0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mask.svg
// module id = 575
// module chunks = 1